import { User } from "../User/User";

export enum AccountType {
  TraditionalSideDoor = "TraditionalSideDoor",
  FirmsPlus = "FirmsPlus",
  Market = "Market",
}

// TODO: Fix this, it's no longer accurate.
export interface Account {
  id: number;
  name: string;
  created_at: string;
  type: AccountType;
  city: string;
  region: string;
  postal_code: string;
  users?: User[];
  product_interactions_count?: number;
}
